const ResultsHeader = ({ displayedSearchQuery, searchTime, totalMedicines, totalDocuments, totalImages, fileTypeCounts, matchedTerms = [] }) => {
  // Aggregate all term frequencies
  const termTotals = matchedTerms.reduce((acc, terms) => {
    if (Array.isArray(terms)) {
      terms.forEach(([term, count]) => {
        acc[term] = (acc[term] || 0) + count;
      });
    }
    return acc;
  }, {});
  console.log('termTotals:', termTotals);
  return (
    <div className="search-results-summary">
      <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
        <h2 style={{ margin: 0 }}>Search Results: </h2>
        <i>{displayedSearchQuery}</i>
        <span>({searchTime && searchTime >= 0.001 ? searchTime.toFixed(3) : "<0.001"}s)</span>
      </span>
      <div className="results-overview">
        <div className="total-results-grid">
          <div className="total-result-item"><span className="result-count">{totalMedicines}</span><span className="result-label"><h2>Medicines with hits</h2></span></div>
          <div className="total-result-item"><span className="result-count">{totalDocuments}</span><span className="result-label"><h2>Documents found</h2></span></div>
          {totalImages > 0 && (<div className="total-result-item"><span className="result-count">{totalImages}</span><span className="result-label"><h2>Images in documents</h2></span></div>)}
        </div>
        <div className="results-by-type">
          {['epar', 'decision', 'annex', 'other'].map(type => (fileTypeCounts[type] && (
            <div className="file-type-result" key={type}><span className={`file-type-bubble file-type-${type.toLowerCase()}`}>{fileTypeCounts[type]}</span><span className="file-type-label">{type}</span></div>
          )))}
        </div>
      </div>
      {Object.keys(termTotals).length > 0 && (
          <div className="terms-overview">
            <h3>Matched Word Frequencies:</h3>
            <div className="terms-overview-grid">
              {Object.entries(termTotals)
                .sort(([, a], [, b]) => b - a) // Sort by frequency, highest first
                .map(([term, count]) => (
                <div key={term} className="term-overview-item">
                  <span className="term-name">{term}</span>
                  <span className="term-total-count">{count}</span>
                </div>
              ))}
            </div>
          </div>
        )}
    </div>
  );
};

export default ResultsHeader;